<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.945 7.81741C12.5196 6.80344 13.9804 6.80344 14.555 7.81742L19.6229 16.7607C20.1895 17.7607 19.4672 19.0002 18.3179 19.0002H8.18212C7.03278 19.0002 6.31045 17.7607 6.87709 16.7607L11.945 7.81741Z"
      stroke="currentColor"
    />
    <rect x="12.75" y="15.5002" width="1" height="1" fill="currentColor" />
    <rect x="12.75" y="10.5002" width="1" height="4" fill="currentColor" />
  </svg>
</template>
